export default __webpack_public_path__ + "static/media/studentCounter.cf965155.svg";